import { HttpClient } from '@angular/common/http';
import { of, BehaviorSubject } from 'rxjs';
import { map, catchError, shareReplay, switchMap } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
// Services
import { StaticFileUrlService } from 'NewAngular/services/static-file-url.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/platform-browser";
import * as i3 from "NewAngular/services/static-file-url.service";
/**
 * SVG Sprite Service
 *
 * Handles loading and inlining of SVG sprite files for improved performance.
 * The sprite is loaded once and cached, then can be referenced locally using #icon-name.
 */
export class SvgSpriteService {
    constructor(http, sanitizer, staticFileUrlService) {
        this.http = http;
        this.sanitizer = sanitizer;
        this.staticFileUrlService = staticFileUrlService;
        this.spriteLoaded$ = new BehaviorSubject(false);
        this.spriteElementId = 'yc-svg-sprite-container';
        // Load sprite on service initialization
        this.spriteContent$ = this.loadSprite();
    }
    /**
     * Load the SVG sprite file and prepare it for inlining
     */
    loadSprite() {
        return this.staticFileUrlService.getRelativeUrl('images/redesign/icons.svg').pipe(switchMap((url) => {
            // Remove any hash fragment from the URL
            const cleanUrl = url.split('#')[0];
            return this.http.get(cleanUrl, { responseType: 'text' });
        }), map((svgContent) => {
            // Sanitize the SVG content
            return this.sanitizer.bypassSecurityTrustHtml(svgContent);
        }), catchError(() => {
            // Failed to load SVG sprite - fall back to null
            return of(null);
        }), shareReplay(1) // Cache the result
        );
    }
    /**
     * Inject the SVG sprite into the DOM
     * Should be called once in the root component or main app component
     */
    inlineSprite() {
        // Check if sprite is already inlined
        if (document.getElementById(this.spriteElementId)) {
            this.spriteLoaded$.next(true);
            return;
        }
        this.spriteContent$.subscribe((safeContent) => {
            if (safeContent) {
                // Create container element
                const container = document.createElement('div');
                container.id = this.spriteElementId;
                container.style.display = 'none';
                container.setAttribute('aria-hidden', 'true');
                // Get the actual HTML content
                const content = this.sanitizer.sanitize(1, safeContent);
                if (content) {
                    container.innerHTML = content;
                    document.body.appendChild(container);
                    this.spriteLoaded$.next(true);
                }
            }
        });
    }
    /**
     * Check if the sprite has been loaded and inlined
     */
    isSpriteLoaded() {
        return this.spriteLoaded$.asObservable();
    }
    /**
     * Get the inline reference for an icon
     * Returns just the hash reference without the full URL
     */
    getInlineReference(iconName) {
        return `#${iconName}`;
    }
}
SvgSpriteService.ɵfac = function SvgSpriteService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SvgSpriteService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.DomSanitizer), i0.ɵɵinject(i3.StaticFileUrlService)); };
SvgSpriteService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SvgSpriteService, factory: SvgSpriteService.ɵfac, providedIn: 'root' });
